exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".parametric-root{width:100%;max-width:600px;height:600px;margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/code/Showcase/Component/Parametric.scss
// module id = 33
// module chunks = 0